import { Component, Inject, OnInit, ViewChild, ChangeDetectorRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogModule, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MaterialModule } from '../../../shared/material.module';
import { EditPyramidalPyramidItemComponent } from "../edit-pyramidal-pyramid-item/edit-pyramidal-pyramid-item.component";
import { PyramidalShareholderPyramidDto } from '../../../models/api/pyramidalShareholderPyramidDto';

export interface EditPyramidalPyramidDialogData {
  pyramidItem: PyramidalShareholderPyramidDto;
  pyramidalShareholderId: string;
  pyramidsByYear?: { [year: number]: PyramidalShareholderPyramidDto[] };
}

@Component({
  selector: 'app-edit-pyramidal-pyramid-dialog',
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule,
    MatIconModule,
    MaterialModule,
    EditPyramidalPyramidItemComponent
  ],
  templateUrl: './edit-pyramidal-pyramid-dialog.component.html',
  styleUrls: ['./edit-pyramidal-pyramid-dialog.component.scss']
})
export class EditPyramidalPyramidDialogComponent implements OnInit {
  @ViewChild(EditPyramidalPyramidItemComponent) editPyramidalPyramidItemComponent!: EditPyramidalPyramidItemComponent;

  isFormValid: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<EditPyramidalPyramidDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: EditPyramidalPyramidDialogData,
    private cdr: ChangeDetectorRef
  ) {
  }

  ngOnInit(): void {}

  onConfirm(): void {
    this.editPyramidalPyramidItemComponent.onConfirm();
  }

  onCancel(): void {
    this.dialogRef.close(null);
  }

  onFormValidityChange(isValid: boolean) {
    // Use setTimeout to defer the update to the next change detection cycle
    setTimeout(() => {
      this.isFormValid = isValid;
      this.cdr.markForCheck();
    });
  }
}
